import { defineComponent as _defineComponent } from 'vue';
import { withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vModelDynamic as _vModelDynamic, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = ["type", "id", "max"];
const _hoisted_2 = ["value"];
import { ref, computed } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'SearchFilterDate',
    props: {
        filter: {}
    },
    setup(__props) {
        const props = __props;
        const choices = ref([
            // the server supports this format to pick the correct day
            'last_hours_1[' + Intl.DateTimeFormat().resolvedOptions().timeZone + ']',
            'last_hours_2[' + Intl.DateTimeFormat().resolvedOptions().timeZone + ']',
            'last_hours_4[' + Intl.DateTimeFormat().resolvedOptions().timeZone + ']',
            'last_hours_12[' + Intl.DateTimeFormat().resolvedOptions().timeZone + ']',
            'last_hours_24[' + Intl.DateTimeFormat().resolvedOptions().timeZone + ']',
            'today[' + Intl.DateTimeFormat().resolvedOptions().timeZone + ']',
            'yesterday[' + Intl.DateTimeFormat().resolvedOptions().timeZone + ']',
            'tomorrow[' + Intl.DateTimeFormat().resolvedOptions().timeZone + ']',
            'current_week[' + Intl.DateTimeFormat().resolvedOptions().timeZone + ']',
            'last_week[' + Intl.DateTimeFormat().resolvedOptions().timeZone + ']',
            'current_month[' + Intl.DateTimeFormat().resolvedOptions().timeZone + ']',
            'last_month[' + Intl.DateTimeFormat().resolvedOptions().timeZone + ']',
            'current_year[' + Intl.DateTimeFormat().resolvedOptions().timeZone + ']',
            'last_year[' + Intl.DateTimeFormat().resolvedOptions().timeZone + ']',
        ]);
        const choicesFiltered = computed(() => {
            return choices.value.filter(choice => {
                return props.filter.filter.type !== 'date'
                    || choice.indexOf('_hours_') === -1;
            });
        });
        const dateMode = ref(true);
        const max = computed(() => {
            if (props.filter.filter.type === 'date') {
                return '9999-12-31';
            }
            return '9999-12-31T23:59';
        });
        if (typeof props.filter.value === 'string') {
            const stringValue = props.filter.value;
            // need to figure out the correct choice based on the value.
            //   The choices may contain a TZ suffix and `stringValue` may
            //   or may not be missing the suffix (e.g. default value), or
            //   may have a different suffix (e.g. retrieved from local
            //   store and the TZ changed).
            const choice = choices.value.find(c => choiceWithoutTz(c) === choiceWithoutTz(stringValue));
            // if we can't find the choice, we leave it in default mode.
            //  Maybe input[date] can make sense of it.
            if (choice) {
                if (props.filter.value !== choice) {
                    console.log("filter.value adjusted", { oldValue: props.filter.value, newValue: choice });
                }
                props.filter.value = choice;
                dateMode.value = false;
            }
        }
        function toggleMode() {
            dateMode.value = !dateMode.value;
            // reset filter value when switching to date input
            if (dateMode.value && typeof props.filter.value === 'string') {
                props.filter.value = undefined;
            }
            // select first choice when switching from date input
            else {
                props.filter.value = choicesFiltered.value[0];
            }
        }
        function choiceWithoutTz(choice) {
            const i = choice.indexOf('[');
            if (i != -1) {
                return choice.substring(0, i);
            }
            return choice;
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("a", {
                    class: _normalizeClass(["search-filter__date-toggle fa-sparkles", {
                            'far': dateMode.value,
                            'fas': !dateMode.value,
                        }]),
                    onClick: _withModifiers(toggleMode, ["prevent"])
                }, null, 2),
                _cache[3] || (_cache[3] = _createTextVNode()),
                (dateMode.value)
                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 0,
                        type: __props.filter.filter.type === 'date' ? 'date' : 'datetime-local',
                        class: "search-filter__input",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((__props.filter.value) = $event)),
                        id: 'filter' + __props.filter.id,
                        max: max.value
                    }, null, 8, _hoisted_1)), [
                        [_vModelDynamic, __props.filter.value]
                    ])
                    : _withDirectives((_openBlock(), _createElementBlock("select", {
                        key: 1,
                        class: "search-filter__date-choice",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((__props.filter.value) = $event)),
                        onClick: _cache[2] || (_cache[2] = _withModifiers(() => { }, ["stop"]))
                    }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(choicesFiltered.value, (choice) => {
                            return (_openBlock(), _createElementBlock("option", {
                                key: choice,
                                value: choice,
                                class: "search-filter__date-choice-option"
                            }, _toDisplayString(_ctx.$t('SearchFilterDate.' + choiceWithoutTz(choice))), 9, _hoisted_2));
                        }), 128))
                    ], 512)), [
                        [_vModelSelect, __props.filter.value]
                    ])
            ]));
        };
    }
});
